import get from 'lodash/get';
import { push } from 'react-router-redux';
import { call, put, take } from 'redux-saga/effects';

import * as D from '../../deps';

const log = D.Logger.child({ component: 'domain/Playback/workers/ArtistAudioMesssageCTA' });

export function* attemptCTAPlayback(ctaLink) {
  const parsedUrl = D.getUrlParseObject(ctaLink, true);
  const pathname = get(parsedUrl, 'pathname', '');
  const query = get(parsedUrl, 'query', {});
  const isRootPathWithStationCode =
    D.Utils.Route.isRootPath(pathname) &&
    D.Constants.App.StartupQueryParameterKeys.START_STATION_BY_CODE in query;
  const isNowPlayingStationPath = D.Utils.Route.isNowPlayingStationRoute(pathname);
  const pandoraId = typeof pathname === 'string' ? pathname.split('/').pop() : null;

  if (isRootPathWithStationCode) {
    yield put(
      D.Actions.UseCases.startStation({
        stationId: query[D.Constants.App.StartupQueryParameterKeys.START_STATION_BY_CODE],
        ...(query[D.Constants.App.StartupQueryParameterKeys.MODE_ID] && {
          modeId: query[D.Constants.App.StartupQueryParameterKeys.MODE_ID],
        }),
      }),
    );

    return query[D.Constants.App.StartupQueryParameterKeys.START_STATION_BY_CODE];
  } else if (isNowPlayingStationPath) {
    yield put(
      D.Actions.UseCases.startStation({
        stationId: pandoraId,
        ...(query[D.Constants.App.StartupQueryParameterKeys.MODE_ID] && {
          modeId: query[D.Constants.App.StartupQueryParameterKeys.MODE_ID],
        }),
      }),
    );

    return pandoraId;
  }

  yield put(
    D.Actions.UseCases.playResumeSource({
      id: pandoraId,
      pandoraType: D.Utils.SourceType.getPandoraTypeFromPandoraId(pandoraId),
    }),
  );

  return pandoraId;
}

export function* handleArtistAudioMessageCTA(action) {
  const ctaLink = action.data;

  if (typeof ctaLink !== 'string') {
    log.error('handleArtistAudioMessageCTA: cta must be a link');
    return;
  }

  const isExternalPath = !D.isUrlLocal(ctaLink);

  if (isExternalPath) {
    D.Utils.Route.navigate(ctaLink, true);
    return;
  }

  const parsedUrl = D.getUrlParseObject(ctaLink, true);
  const pathname = get(parsedUrl, 'pathname', '');
  const query = get(parsedUrl, 'query', {});
  const isRootPathWithStationCode =
    D.Utils.Route.isRootPath(pathname) &&
    D.Constants.App.StartupQueryParameterKeys.START_STATION_BY_CODE in query;
  const isNowPlayingStationPath = D.Utils.Route.isNowPlayingStationRoute(pathname);
  const isNowPlayingPath = D.Utils.Route.isPathInNowPlayingPath(pathname);
  const isNonPlaybackInternalPath =
    !isNowPlayingPath && !isNowPlayingStationPath && !isRootPathWithStationCode;

  if (isNonPlaybackInternalPath) {
    // given https://www.pandora.com/playlist/PL:1125899936684600:819647497?ag=-16328658384925447
    // path is /playlist/PL:1125899936684600:819647497?ag=-16328658384925447
    // and pathname is /playlist/PL:1125899936684600:819647497 (ie. excludes query params)
    const path = get(parsedUrl, 'path', '');
    yield put(push(path));
    return;
  }

  const pandoraId = yield call(attemptCTAPlayback, ctaLink);
  const playbackAction = yield take([
    D.Constants.Integrations.ActionTypes.START_SOURCE_INCOMPLETE,
    D.Constants.Integrations.ActionTypes.SOURCE_STARTED,
  ]);
  const shouldLaunchFallback =
    playbackAction?.type === D.Constants.Integrations.ActionTypes.START_SOURCE_INCOMPLETE &&
    playbackAction?.payload.sourceId === pandoraId;

  if (shouldLaunchFallback) {
    D.Utils.Route.navigate(ctaLink, true);
  }
}
